var render = function render(_c,_vm){return _c('div',{staticClass:"navbar__logo"},[_c('div',{staticClass:"navbar__logo__icon",domProps:{"innerHTML":_vm._s(_vm.props.logoIcon)}}),_c('h2',{staticClass:"navbar__label"},[_vm._v("Grażka")])])
}
var staticRenderFns = []

export { render, staticRenderFns }